import { Component } from "react";
import { Col, Container, Row , TabContent, TabPane, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab";
import classnames from 'classnames';
import VoyAdvCard from "../../../components/common/Voyages/VoyAdvCard";
import '../../../style/css/particulier/hebergement.css'
import { NavLink } from "react-router-dom";
import AnnounceRow from "../../../components/common/announceRow";



class Mon_Voyage_Omra extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            activeTab : "Visas"
         }

    }
    render() { 
        const activeTab = this.state.activeTab
        const toggle = tab => {
            if(activeTab !== tab) this.setState({activeTab:tab});
          }
        return (
          <>
            <Container>
              <NavTab display="none" />
       
              <center>
                <h3 className="title-70 mt-4">J'Organise mon Voyage Omra</h3>
              </center>

              <Row className="voyage__nav justify-content-between text-center pt-5 ">
                <Col sm="12">
                  <ul className="zindex list-unstyled list-inline">
                    <div
                      onClick={() => {
                        toggle("Visas");
                      }}
                      className={classnames(
                        { active_haj_bg: activeTab === "Visas" },
                        "list-inline-item item-nT-haj px-4 mx-0 py-2  d-inline-block"
                      )}
                    >
                      <li
                        className={classnames({
                          active_haj_cl: activeTab === "Visas",
                        })}
                      >
                        Visas
                      </li>
                    </div>
                    <div
                      onClick={() => {
                        toggle("Vols");
                      }}
                      className={classnames(
                        { active_haj_bg: activeTab === "Vols" },
                        "list-inline-item item-nT-haj px-4 mx-0 py-2  d-inline-block"
                      )}
                    >
                      <li
                        className={classnames({
                          active_haj_cl: activeTab === "Vols",
                        })}
                      >
                        Vols
                      </li>
                    </div>
                    <div
                      onClick={() => {
                        toggle("Hotels");
                      }}
                      className={classnames(
                        { active_haj_bg: activeTab === "Hotels" },
                        "list-inline-item item-nT-haj px-4 mx-0 py-2  d-inline-block"
                      )}
                    >
                      <li
                        className={classnames({
                          active_haj_cl: activeTab === "Hotels",
                        })}
                      >
                        Hotels
                      </li>
                    </div>
                    <div
                      onClick={() => {
                        toggle("Ziyarat");
                      }}
                      className={classnames(
                        { active_haj_bg: activeTab === "Ziyarat" },
                        "list-inline-item item-nT-haj px-4 mx-0 py-2  d-inline-block"
                      )}
                    >
                      <li
                        className={classnames({
                          active_haj_cl: activeTab === "Ziyarat",
                        })}
                      >
                        Ziyarat
                      </li>
                    </div>

                    <div
                      onClick={() => {
                        toggle("Transfert");
                      }}
                      className={classnames(
                        { active_haj_bg: activeTab === "Transfert" },
                        "list-inline-item item-nT-haj px-4 mx-0 py-2  d-inline-block"
                      )}
                    >
                      <li
                        className={classnames({
                          active_haj_cl: activeTab === "Transfert",
                        })}
                      >
                        Transfert
                      </li>
                    </div>
                    <div
                      onClick={() => {
                        toggle("Guides");
                      }}
                      className={classnames(
                        { active_haj_bg: activeTab === "Guides" },
                        "list-inline-item item-nT-haj px-4 mx-0 py-2  d-inline-block"
                      )}
                    >
                      <li
                        className={classnames({
                          active_haj_cl: activeTab === "Guides",
                        })}
                      >
                        Guides
                      </li>
                    </div>
                    
                  </ul>
                </Col>
                <NavLink className="voyage__panierIcon" style={{height:"40px",marginTop:"-55px",float:"right"}}  to="/voyages/haj_omra_circuit/offres_hajj/mon_voyage/mon_panier">
                      
                        
                          <img src="/imgs/navebar/shopingIcon.svg" className="basket-icon-nvTab" alt="shopingIcon" />
                       
                 </NavLink>
              </Row>
              

              <Row className="px-3 mx-1 my-0 py-0">
                
                <div className="result-box px-2">
                
               
                        
        
              
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="Visas">
                      <Row className="px-0 mx-1 mt-3">
                        <Col sm="6" className="pr-1">
                          <Row>
                            <Col sm="8" className="pr-1">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  27/02/2021 - 11/03/2021
                                  <img
                                    style={{ width: "20px", marginTop: "3px" }}
                                    src="/imgs/ghurfatiFilter/calendar_icn.svg"
                                    alt="calendar_icn"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                                <Row>
                                  <DropdownMenu className="destination-drop-down"></DropdownMenu>
                                </Row>
                              </UncontrolledDropdown>
                            </Col>
                            <Col sm="4" className="pl-1">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  2 Adultes
                                  <img
                                    src="/imgs/navebar/downArrow.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm="6" className="pl-1">
                          <Row>
                            <Col sm="4" className="pr-1">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  0 Enfants
                                  <img
                                    src="/imgs/navebar/downArrow.svg"
                                    alt="parcourir"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                            <Col sm="8" className="pl-1">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="rech-navtab">
                                  Recherche
                                  <img
                                    src="/imgs/navebar/search.svg"
                                    id="nav-haj-zm"
                                    alt='search'
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Container className="mt-5 text-left">
                        <Row className=" ml-1  text-right">
                          <span className="hd-title-Rslt">Résultats</span>
                          <Col sm="3" className="offset-sm-8">
                            <span className="Promotion-badge nn-clr px- mr-3">
                              Promotion
                            </span>
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Prix</span>
                            <img src="/imgs/navebar/downArrow_red.svg" className="rd-clr mr-3" alt="downArrow_red" />
                          </Col>
                        </Row>
                        <hr style={{ width: "100%" }} className="mb-4" /> 
                        <AnnounceRow
                img="/imgs/announces/index.png"
                imgWidth="25%"
                title="Vol Omra - Titre de l'offre"
                description="Hello word"
                prix="12 000"
                contact
                  favoris
                  addPanier
                announceDetails="Lorem Ipsum is simply text offf the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy when an unknown printer took a galley of type and scrambled it to make a type specimen book."
              />
                        <AnnounceRow 
                  img="/imgs/announces/index.png"
                  imgWidth="23%"  
                  title="Hotel"
                  description="Hello word"
                  prix="12 000 "
                
                  contact
                  favoris
                  addPanier
                  />
                  <AnnounceRow 
                  img="/imgs/announces/index.png"
                  imgWidth="23%"  
                  title="Hotel"
                  description="Hello word"
                  prix="12 000 "
                promotion
                  contact
                  favoris
                  addPanier
                  />
                      </Container>
                    </TabPane>
                    <TabPane tabId="Vols">
                      <Row className="px-0 mx-3 mt-3">
                        <Col sm="7" className="pr-1 mx-0 pl-0">
                          <Row className="px-0 mx-0">
                            <Col sm="4" className="px-0 mx-0 pr-2">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  Choisir un circuit
                                  <img
                                    src="/imgs/navebar/downArrow.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                            <Col sm="2" className="px-0 mx-0">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  0 Enfants
                                  <img
                                    src="/imgs/navebar/downArrow.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                            <Col sm="6" className="pl-2 px-0 mx-0">
                              {" "}
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  Aller - Retour
                                  <img
                                    style={{ width: "20px", marginTop: "3px" }}
                                    src="/imgs/ghurfatiFilter/calendar_icn.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm="5" className="px-0 mx-0 pr-2">
                          <Row className="px-0 mx-0">
                            <Col sm="4" className="px-0 mx-0 pr-2">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  2 Adultes
                                  <img
                                    src="/imgs/navebar/downArrow.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                            <Col sm="4" className="px-0 mx-0 pr-2">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="navTab-hajj">
                                  0 Enfants
                                  <img
                                    src="/imgs/navebar/downArrow.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                            <Col sm="4" className="px-0 mx-0">
                              <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle className="rech-navtab">
                                  Recherche
                                  <img
                                    src="/imgs/navebar/search.svg"
                                    id="nav-haj-zm"
                                    alt='search'
                                  />
                                </DropdownToggle>
                              </UncontrolledDropdown>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Container className="mt-5 text-left">
                        <Row className=" ml-3 mr-5 text-right">
                          <span className="hd-title-Rslt">Résultats</span>
                          <Col sm="3" className="offset-sm-8">
                            <span className="Promotion-badge nn-clr px- mr-3">
                              Promotion
                            </span>
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Prix</span>
                            <img src="/imgs/navebar/downArrow_red.svg" className="rd-clr" alt="downArrow" />
                          </Col>
                        </Row>
                        <hr style={{ width: "100%" }} className="mb-4" />
                        <AnnounceRow 
                            img="https://pix10.agoda.net/hotelImages/200524/-1/e7e36079645da64601ea20c5249c367d.jpg?s=1024x768"
                            imgWidth="35%"  
                            title="Hotel"
                            description="Hello word"
                            prix="12 000 "
                            rating
                            details
                            contact
                            favoris
                            addPanier
                            />
                        <AnnounceRow 
                            img="https://pix10.agoda.net/hotelImages/200524/-1/e7e36079645da64601ea20c5249c367d.jpg?s=1024x768"
                            imgWidth="35%"  
                            title="Hotel"
                            description="Hello word"
                            prix="12 000 "
                            rating
                            details
                            contact
                            favoris
                            addPanier
                            />
                       <AnnounceRow 
                            img="https://pix10.agoda.net/hotelImages/200524/-1/e7e36079645da64601ea20c5249c367d.jpg?s=1024x768"
                            imgWidth="35%"  
                            title="Hotel"
                            description="Hello word"
                            prix="12 000 "
                            rating
                            details
                            contact
                            favoris
                            addPanier
                            />
                        <AnnounceRow 
                            img="https://pix10.agoda.net/hotelImages/200524/-1/e7e36079645da64601ea20c5249c367d.jpg?s=1024x768"
                            imgWidth="35%"  
                            title="Hotel"
                            description="Hello word"
                            prix="12 000 "
                            rating
                            details
                            contact
                            favoris
                            addPanier
                            />
                      </Container>
                    </TabPane>
                    <TabPane tabId="Hotels">
                      <Container>
                        <Row className="px-0 mx-3 mt-3 mr-4 pr-1">
                          <Col sm="7" className="px-0 mx-0">
                            <Row className="pr-2">
                              <Col sm="4" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    Distance du Haram
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="3" className="px-0 mx-0 pl-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    Budget
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="5" className="px-0 mx-0 pl-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    21/07/2021 - 11/08/2021
                                    <img
                                      style={{
                                        width: "20px",
                                        marginTop: "3px",
                                      }}
                                      src="/imgs/ghurfatiFilter/calendar_icn.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                          <Col sm="5">
                            <Row className="px-0 mx-0">
                              <Col sm="4" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    2 Adultes
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="4" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    0 Enfants
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="4" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="rech-navtab">
                                    Recherche
                                    <img
                                      src="/imgs/navebar/search.svg"
                                      id="nav-haj-zm"
                                      alt='search'

                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Container>
                      <Container className="mt-5 text-left">
                        <Row className=" ml-3 mr-5 text-right">
                          <span className="hd-title-Rslt">Résultats</span>
                          <Col sm="3" className="offset-sm-8">
                            <span className="Promotion-badge nn-clr px- mr-3">
                              Promotion
                            </span>
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Prix</span>
                            <img src="/imgs/navebar/downArrow_red.svg" className="rd-clr mr-3" alt="downArrow" />
                          </Col>
                        </Row>
                        <hr style={{ width: "100%" }} className="mb-4" />
                        <VoyAdvCard
                          title="Hotels Mercure"
                          description="Chambre double - 500m"
                          prix="1232"
                          linkPath={`/`}
                          promotion={true}
                        />
                        <VoyAdvCard
                          title="Hotel Essalem"
                          description="Chambre simple - 500m"
                          prix="1232"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="Hotel Safir"
                          description="21/03/2020 - 11/02/2021"
                          prix="1232"
                          linkPath={`/`}
                        />
                      </Container>
                    </TabPane>
                    <TabPane tabId="Ziyarat">
                      <Container>
                        <Row className="px-0 mx-3 mt-3  mr-4 pr-1">
                          <Col sm="7" className="px-0 mx-0">
                            <Row className="pr-2">
                              <Col sm="6" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    Destination
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="6" className="px-0 mx-0 pl-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    21/07/2021 - 11/08/2021
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                          <Col sm="5">
                            <Row className="px-0 mx-0">
                              <Col sm="4" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    2 Adultes
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="4" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    0 Enfants
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="4" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="rech-navtab">
                                    Recherche
                                    <img
                                      src="/imgs/navebar/search.svg"
                                      id="nav-haj-zm"
                                      alt='search'

                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Container>
                      <Container className="mt-5 text-left">
                        <Row className=" ml-3 mr-5 text-right">
                          <span className="hd-title-Rslt">Résultats</span>
                          <Col sm="6" className="offset-sm-5">
                            <span className="Promotion-badge nn-clr px- mr-3">
                              Promotion
                            </span>
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Distination di Haram</span>
                            <img
                              className="mr-4"
                              src="/imgs/navebar/downArrow.svg"
                              alt="downArrow"
                            />
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Prix</span>
                            <img src="/imgs/navebar/downArrow_red.svg" className="rd-clr" alt="downArrow" />
                          </Col>
                        </Row>
                        <hr style={{ width: "100%" }} className="mb-4" />
                        <AnnounceRow 
                         img="https://pix10.agoda.net/hotelImages/200524/-1/e7e36079645da64601ea20c5249c367d.jpg?s=1024x768"
                         imgWidth="35%"  
                         title="Hotel"
                         description="Hello word"
                         prix="12 000 "
                         rating
                         details
                         contact
                         favoris
                         addPanier
                         />
                        <VoyAdvCard
                          title="AL Taeif"
                          description="21/04/2020 - 12/04/2020"
                          prix="12 000"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="AL Taeif"
                          description="21/04/2020 - 12/04/2020"
                          prix="18 000"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="AL Taeif"
                          description="21/04/2020 - 12/04/2020"
                          prix="18 000"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="AL Taeif"
                          description="21/04/2020 - 12/04/2020"
                          prix="18 000"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="AL Taeif"
                          description="21/04/2020 - 12/04/2020"
                          prix="18 000"
                          linkPath={`/`}
                        />
                      </Container>
                    </TabPane>
                    <TabPane tabId="Transfert" >
                      <Container>
                        <Row className="px-0 mx-3 mt-3 mr-4 pr-1">
                          <Col sm="6" className="px-0 mx-0">
                            <Row className="pr-2">
                              <Col sm="6" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    Départ
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="6" className="px-0 mx-0 pl-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    21/07/2021
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                          <Col sm="6">
                            <Row className="px-0 mx-0">
                              <Col sm="3" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    10:00
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="5" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      className="up mr-2"
                                      alt="downArrow"
                                    />
                                    <span className="mr-2">2</span>
                                    <img
                                    className="mr-3"
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                    />
                                    Personnes
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="4" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="rech-navtab">
                                    Recherche
                                    <img
                                      src="/imgs/navebar/search.svg"
                                      id="nav-haj-zm"
                                      alt='search'
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Container>
                      <Container className="mt-5 text-left">
                        <Row className=" ml-3 mr-5 text-right">
                          <span className="hd-title-Rslt">Résultats</span>
                          <Col sm="6" className="offset-sm-5">
                            <span className="Promotion-badge nn-clr px- mr-3">
                              Promotion
                            </span>
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Distination di Haram</span>
                            <img
                              className="mr-4"
                              src="/imgs/navebar/downArrow.svg"
                              alt="downArrow"
                            />
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Prix</span>
                            <img src="/imgs/navebar/downArrow_red.svg" className="rd-clr" alt="downArrow" />
                          </Col>
                        </Row>
                        <hr style={{ width: "100%" }} className="mb-4" />
                        <VoyAdvCard
                          title="Transfert Hotel -Costantine - DZ"
                          description="Hello Family"
                          prix="5000"
                          linkPath={`/`}
                          promotion={true}
                        />
                        <VoyAdvCard
                          title="Transfert Hotel -Madina - SA"
                          description="Hello Family"
                          prix="12 000"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="Transfert Hotel -Mecca - SA"
                          description="Hello Family"
                          prix="12 000"
                          linkPath={`/`}
                        />
                      </Container>
                    </TabPane>
                    <TabPane tabId="Guides">
                    <Container>
                        <Row className="px-0 mx-3 mt-3  mr-4 pr-1">
                          <Col sm="6" className="px-0 mx-0">
                            <Row className="pr-2">
                              <Col sm="6" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    Mecca -SA
                                    <img
                                      src="/imgs/navebar/downArrow.svg"
                                      alt="downArrow"
                                      id="arrow-parcourir-big"
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="6" className="px-0 mx-0 pl-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    21/07/2021
                                    <img
                                    style={{ width: "20px", marginTop: "3px" }}
                                    src="/imgs/ghurfatiFilter/calendar_icn.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                          <Col sm="6">
                            <Row className="px-0 mx-0">
                            <Col sm="6" className="px-0 mx-0 pr-2">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="navTab-hajj">
                                    21/07/2021
                                    <img
                                    style={{ width: "20px", marginTop: "3px" }}
                                    src="/imgs/ghurfatiFilter/calendar_icn.svg"
                                    alt="downArrow"
                                    id="arrow-parcourir-big"
                                  />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                              <Col sm="6" className="px-0 mx-0">
                                <UncontrolledDropdown nav inNavbar>
                                  <DropdownToggle className="rech-navtab">
                                    Recherche
                                    <img
                                      src="/imgs/navebar/search.svg"
                                      id="nav-haj-zm"
                                      alt='search'
                                    />
                                  </DropdownToggle>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Container>
                      <Container className="mt-5 text-left">
                        <Row className=" ml-3 mr-5 text-right">
                          <span className="hd-title-Rslt">Résultats</span>
                          <Col sm="6" className="offset-sm-5">
                            <span className="Promotion-badge nn-clr px- mr-3">
                              Promotion
                            </span>
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Distination di Haram</span>
                            <img
                              className="mr-4"
                              src="/imgs/navebar/downArrow.svg"
                              alt="downArrow"
                            />
                            <img
                              src="/imgs/navebar/downArrow.svg"
                              className="up mr-3"
                              alt="downArrow"
                            />
                            <span className="mr-3">Prix</span>
                            <img src="/imgs/navebar/downArrow_red.svg" className="rd-clr" alt="downArrow" />
                          </Col>
                        </Row>
                        <hr style={{ width: "100%" }} className="mb-4" />
                        <VoyAdvCard
                          title="Local Guide - Makkah - SA"
                          description="Homme, Natiolnalité - Algérienne, Age: 35ans"
                          prix="5000"
                          linkPath={`/`}
                          promotion={true}
                        />
                        <VoyAdvCard
                          title="Local Guide - Madina - SA"
                          description="Homme, Natiolnalité - Algérienne, Age: 33ans"
                          prix="12000"
                          linkPath={`/`}
                        />
                        <VoyAdvCard
                          title="Local Guide for Women - Makkah - SA"
                          description="Femme, Natiolnalité - Algérienne, Age: 25ans"
                          prix="18000"
                          linkPath={`/`}
                        />
                      </Container>
                    </TabPane>
                  </TabContent>
                </div>
              </Row>
              {/*
              <Row>
                <Container id="left-tabs-example">
                  <Nav tabs className="px-2">
                    <NavItem className="mr-2">
                      <NavLink
                        style={{ color: "red", backgroundColor: "black" }}
                        onClick={() => {
                          toggle("1");
                        }}
                        className={classnames({ active: activeTab === "1" })}
                      >
                        Home
                      </NavLink>
                    </NavItem>
                    <NavItem className="mr-2">
                      <NavLink
                        style={{ color: "red", backgroundColor: "black" }}
                        onClick={() => {
                          toggle("2");
                        }}
                        className={classnames({ active: activeTab === "1" })}
                      >
                        Profile
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ color: "red", backgroundColor: "black" }}
                        onClick={() => {
                          toggle("3");
                        }}
                        className={classnames({ active: activeTab === "1" })}
                      >
                        Contact
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">hello1</TabPane>
                    <TabPane tabId="2">hello3</TabPane>
                    <TabPane tabId="3">hello2</TabPane>
                  </TabContent>
                </Container>
              </Row>
              <br />
              <br /> 




              */}
              <br />
            </Container>
          </>
        );
    }
}
 
export default Mon_Voyage_Omra;